import { render, staticRenderFns } from "./BuyPackagePage.vue?vue&type=template&id=789da90a&scoped=true&"
import script from "./BuyPackagePage.vue?vue&type=script&lang=js&"
export * from "./BuyPackagePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789da90a",
  null
  
)

export default component.exports